import React from 'react';
import LabImages from '../LabImages';
import LabResults from '../LabResults';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core';
import WithPatientFileHeader from '../../PatientFileHeader/WithPatientFileHeader';
// import NavBar from '../../NavBar';

const useStyles = makeStyles((theme) => ({
    container: {
        maxWidth: '100%',
        width: '100%',
        position: 'relative',
        // padding: 16,
        background: '#fff',

        [theme.breakpoints.down(1025)]: {
            overflow: 'hidden',
            padding: '0',
            background: '#ced2d6',
            maxWidth: 'unset',
            width: 'unset'
        }
    },
    labResultWrapper: {
        background: '#fff'
    }
}));
function LaboratoryHome() {
    const classes = useStyles();

    return (
        <>
            <div className={classes.container}>
                <LabImages />
                <div className={classes.labResultWrapper}>
                    <LabResults />
                </div>
            </div>
        </>
    );
}

LaboratoryHome.propTypes = {
    match: PropTypes.any
};

export default WithPatientFileHeader(LaboratoryHome, ['sidebar', 'laboratory'], 'white');
